import { Breed } from "./Breed";

export class Entity<T extends Breed> {
  constructor(
    public id: number,
    public breed: T,
    public x: number = 0,
    public y: number = 0
  ) {}
}
